var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCelo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: "24px",
    height: "24px",
    viewBox: "0 0 32 32",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "social icon for Celo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FBCC5C",
    d: "M12.63 28.63a9.26 9.26 0 1 0 0-18.52 9.26 9.26 0 0 0 0 18.52Zm0 3.37a12.63 12.63 0 1 1 0-25.26 12.63 12.63 0 0 1 0 25.26Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#35D07F",
    d: "M19.37 21.9a9.26 9.26 0 1 0 0-18.53 9.26 9.26 0 0 0 0 18.52Zm0 3.36a12.63 12.63 0 1 1 0-25.26 12.63 12.63 0 0 1 0 25.26Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#5EA33B",
    d: "M19.79 25.26a9.22 9.22 0 0 0 1.83-3.64 9.27 9.27 0 0 0 3.64-1.83 12.54 12.54 0 0 1-.98 4.5c-1.42.6-2.95.93-4.5.97Zm-9.41-14.88a9.27 9.27 0 0 0-3.64 1.83c.04-1.54.38-3.06.98-4.49 1.43-.6 2.95-.93 4.5-.98a9.22 9.22 0 0 0-1.84 3.64Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelo);
export default __webpack_public_path__ + "static/media/celo.70fc016b610e02ef588ed09583293ba1.svg";
export { ForwardRef as ReactComponent };